import { FaMapMarkerAlt } from "react-icons/fa";
import PropertiesMapView from "../../components/PropertiesMapView";

function PropertiesMap() {
  return (
    <div className="mt-28">
      <div className="container mx-auto px-4 pt-6 pb-4">
        <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 flex items-center gap-2">
          <FaMapMarkerAlt className="text-primary" />
          Mapa de propiedades
        </h1>
        <p className="text-gray-500 mt-1">
          Tocá un pin para ver el detalle de cada propiedad
        </p>
      </div>

      <PropertiesMapView heightClass="h-[78vh]" />
    </div>
  );
}

export default PropertiesMap;
